import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

import { withGlobalContext } from "../common/GlobalContext";

type Props = {
  classes: Object,
  className: string,
  compliance: Object,
};

const DisclaimerSold = ({ classes, className, compliance }: Props) => {
  if (!(compliance && compliance.soldListingsDisclaimer)) {
    return null;
  }

  return (
    <div
      className={classNames(classes.root, className)}
      id="ref__soldListingsDisclaimer"
    >
      {compliance.soldListingsDisclaimer}
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    width: "100%",
    color: theme.colors.gray["900"],
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: "600",
    textAlign: "center",
    paddingTop: theme.spacing.unit * 2,
    borderTop: `1px solid ${theme.colors.gray["200"]}`,
    marginBottom: theme.spacing.unit * 2,
  },
}))(withGlobalContext(DisclaimerSold));
